// extracted by extract-css-chunks-webpack-plugin
module.exports = {"addToListBlock":"hijfP","addToListTooltip":"_5OEe8","heartIconButton":"MN0kS"};